<template>
  <div :id="id" v-show="false"></div>
</template>
<script>
import appsettings from "../utils/appsettings";
import generator from "../utils/generator";
import Vue from "vue";
import { fetch } from "../utils/request";
import { isImg, isVideo } from "../utils/rules";
//支持分片上传文件
export default {
  name: "el-chunkuploader",
  props: {
    accept: {
      type: String
    }
  },
  data: function () {
    return {
      appsettings: appsettings,
      id: "webuploader_" + new Date().getTime() + Math.floor(Math.random() * 999),
      uploadingFiles: [], //正在上传的文件列表
      uploadingList: [], //已经上传成功的列表
      uploader: {},
      progresschange_callback: null, //上传进度回调
      success_callback: null, //上传成功回调
      uploadFileQueued_cb: null,//文件被加入时回调
      successFiles: [], //上传成功的文件列表
      formData: {},
      token: null,
      threads: 1
    };
  },
  components: {},
  mounted: function () {
    var self = this;
    self.__InitUploader();
    // setTimeout(() => {
    //   self.__InitUploader();
    // }, 1000);
    this.token = localStorage.getItem("token") || "cssc";
  },
  created: function () { },
  watch: {},
  methods: {
    //移除一个文件
    remove: function (fid) {
      this.uploadingFiles.removeByKeyAndValue("fid", fid);
      this.successFiles.removeByKeyAndValue("fid", fid);
    },
    //清除列表数据
    clear: function () {
      this.uploadingFiles = [];
      this.successFiles = [];
    },
    //上传多个新文件
    uploadNewFiles: function (
      form_data = { url: '/attachment/upload', multiple: true },
      progresschange_callback,
      success_callback,
      uploadFileQueued_cb
    ) {
      this.uploader.options.server = appsettings.apiroot + form_data.url;
      this.uploader.options.multiple = form_data.multiple;
      this.formData = form_data;
      this.success_callback = success_callback;
      this.progresschange_callback = progresschange_callback;
      this.uploadFileQueued_cb = uploadFileQueued_cb;
      $(
        document
          .getElementById(this.id)
          .getElementsByClassName("webuploader-element-invisible")[0]
      ).click();
    },
    __InitUploader: function () {
      var self = this;
      this.uploader = WebUploader.create({
        // swf文件路径
        swf: appsettings.assetsroot + "plugins/webuploader/Uploader.swf",
        // 文件接收服务端。
        server: appsettings.apiroot + '/attachment/upload',
        chunked: true,
        threads: self.threads,
        auto: true,
        fromData: {
          guid: "guid"
        },
        // 选择文件的按钮。可选。
        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: "#" + self.id,
        multiple: true,
        // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
        resize: false,
        chunkSize: 1024 * 1024 * 5, //分片，每片5M
        duplicate: true,
        accept: null
      });

      this.uploader.on('beforeFileQueued', function (file) {
        if (!isImg('.' + file.source.ext) && !isVideo(file.source.ext) && self.formData.from == 'scene') {
          self.$message.warning('请上传图片或视频格式的文件')
          return false
        } else {
          return true
        }
      })
      this.uploader.on("uploadProgress", function (file, percentage) {
        file.progress = Number((percentage * 100 + "").substring(0, 3));

        Vue.set(self.uploadingFiles, file.index, file);
        self.progresschange_callback(file, self.uploadingFiles);
      });

      this.uploader.on("uploadBeforeSend", function (obj, data, headers) {
        Object.keys(obj.file.formData).forEach(function (key) {
          data[key] = obj.file.formData[key];
        });
      });

      this.uploader.on("uploadAccept", function (file, response) {
        response = JSON.parse(response);
        if (response != null) {
          if (response.status == 0) {
            return true;
          } else if (response.status == 9999) {
            self.$router.push({ path: "/login", query: { goindex: true } });
            // window.location.href =
            //   "/#/login?ref=" + encodeURIComponent(window.location.href);
            return false;
          }
        }
      });

      this.uploader.on("fileQueued", function (file) {
        file.index = self.uploadingFiles.length;
        file.fid =
          "fid_" + new Date().getTime() + Math.floor(Math.random() * 999);
        file.progress = 0;
        file.formData = self.formData;
        file.formData.guid = Math.random();
        file.formData.token = window.localStorage.getItem("token");
        file.formData.file_type = file.ext;
        file.formData.file_size = file.size;
        file.formData.file_name = file.name;
        file.file_name = file.name;
        file.file_type = file.ext;
        self.uploadingFiles.push(file);
        if (self.uploadFileQueued_cb) {
          self.uploadFileQueued_cb(
            file,
            self.uploadingFiles
          );
        }

      });
      this.uploader.on("uploadSuccess", function (file, response) {
        response = JSON.parse(response);
        // response.data = {};
        if (response != null) {
          if (response.status == 0) {
            var item = {};
            item.file_oid = response.data.oid;
            item.resource_name = response.data.file_name;
            item.resource_type = response.data.file_type;
            response.index = file.index;
            self.uploadingList.push(item);
            self.success_callback(
              response.data,
              response,
              self.uploadingList
            );
          } else if (response.status == 9999) {
            // window.location.href =
            //   "/#/login?ref=" + encodeURIComponent(window.location.href);
          } else {
            //self.uploadingFiles.removeByKeyAndValue("fid", file.fid);
            self.success_callback(
              response.data,
              response,
              self.uploadingList
            );
          }
        }
      });

      this.uploader.on("uploadError", function (file) {
        
       });
      this.uploader.on("uploadComplete", function (file) { });

    },
    refresh: function () {
      this.uploader.refresh();
    },
    stop () {
      this.uploader.stop(true);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue